import ProductQuantity from '@/app-theme/components/product/ProductQuantity.vue'
import Translatable from '@/app-core/mixins/translatable'
import ProductListCommon from '@/app-core/mixins/product/productListCommon'
import ProductPrice from '@/app-theme/components/product/ProductPrice.vue'
import ProductTags from '@/app-theme/components/product/ProductTags.vue'

export default {
  name      : 'CheckoutProductListItem',
  components: {
    ProductTags,
    ProductPrice,
    ProductQuantity
  },
  directives: {},
  mixins    : [Translatable, ProductListCommon],
  props     : {
    product: {
      type   : Object,
      default: undefined
    },

    storeLogo: {
      type   : Boolean,
      default: false
    },

    showProductTags: {
      type   : Boolean,
      default: false
    }
  },
  dataStore: {},
  data() {
    return {}
  },
  computed: {
    imageWidth() {
      return this.$vuetify.breakpoint.smAndUp ? 150 : 110
    },

    imageHeight() {
      return 75
    },

    storeLogoStyle() {
      return this.$vuetify.breakpoint.smAndUp ? {
        Size: 40,
        Top : -8,
        Left: -3
      } : {
        Size: 28,
        Top : 3,
        Left: 3
      }
    }
  },
  watch: {},
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {}
}
